import type { Directive } from 'vue';

type RotateOptions = {
  isRotated: boolean;
  from?: number;
  to?: number;
};

const setTransform = (element: HTMLElement, isRotated: boolean, from = 0, to = 180) => {
  element.style.transform = `rotate(${isRotated ? to : from}deg)`;
};

const rotate = (element: HTMLElement, value?: boolean | RotateOptions) => {
  if (!value || typeof value === 'boolean') {
    setTransform(element, value !== false);
  } else {
    setTransform(element, value.isRotated, value.from, value.to);
  }
};

export default {
  beforeMount(element, { value }) {
    element.style.transition = 'all var(--transition)';
    rotate(element, value);
  },
  updated(element, { value }) {
    rotate(element, value);
  },
} satisfies Directive<HTMLElement, RotateOptions>;
